import { baseUrl } from '@/api/types';

export function moduleIndexUrl() {
  return `${baseUrl}/modules`;
}

export function sipModuleEditUrl() {
  return `${moduleIndexUrl()}/sip`;
}

export function sipModuleUpdateUrl() {
  return `${moduleIndexUrl()}/sip`;
}

export function sipExpensesModuleEditUrl() {
  return `${moduleIndexUrl()}/sip-expenses`;
}

export function moduleStoreUrl() {
  return `${moduleIndexUrl()}`;
}

export function moduleDeactivateUrl() {
  return `${baseUrl}/modules/deactivate`;
}

export function moduleShowUrl(type) {
  return `${moduleIndexUrl()}/${type}/show`;
}

export function moduleEnableUpdateUrl() {
  return `${moduleIndexUrl()}/toggle`;
}

export function apiModuleEditUrl() {
  return `${moduleIndexUrl()}/api`;
}

export function optimumModuleEditUrl() {
  return `${moduleIndexUrl()}/optimum`;
}

export function lobasoftModuleEditUrl() {
  return `${moduleIndexUrl()}/lobasoft`;
}

export function centasModuleEditUrl() {
  return `${moduleIndexUrl()}/centas`;
}

export function debetasModuleEditUrl() {
  return `${moduleIndexUrl()}/debetas`;
}

export function invoiceImportModuleEditUrl() {
  return `${moduleIndexUrl()}/invoice-import`;
}

export function rivileModuleEditUrl() {
  return `${moduleIndexUrl()}/rivile`;
}

export function rivileModuleUpdateUrl() {
  return `${moduleIndexUrl()}/rivile`;
}

export function rivileWarehouseModuleEditUrl() {
  return `${moduleIndexUrl()}/rivile-warehouse`;
}

export function rivileWarehouseModuleUpdateUrl() {
  return `${moduleIndexUrl()}/rivile-warehouse`;
}

export function documentModuleEditUrl() {
  return `${moduleIndexUrl()}/document`;
}

export function commercialSuggestionModuleSettings() {
  return `${moduleIndexUrl()}/commercial-suggestion`;
}

export function commercialSuggestionModuleSettingsUpdate() {
  return `${moduleIndexUrl()}/commercial-suggestion-settings`;
}

export function agnumModuleEditUrl() {
  return `${moduleIndexUrl()}/agnum`;
}

export function agnumModuleUpdateUrl() {
  return `${moduleIndexUrl()}/agnum/update`;
}

export function companyContractModuleEditUrl() {
  return `${moduleIndexUrl()}/company-contract`;
}

export function companyContractModuleUpdateUrl() {
  return `${moduleIndexUrl()}/company-contract/update`;
}

export function bankInvoiceImportModuleEditUrl() {
  return `${baseUrl}/modules/bank-invoice-import`;
}

export function smtpModuleEditUrl() {
  return `${baseUrl}/modules/smtp`;
}

export function smtpModuleUpdateUrl() {
  return `${baseUrl}/modules/smtp/update`;
}

export function smtpTestUrl() {
  return `${baseUrl}/smtp-test`;
}

export function isafModuleEditUrl() {
  return `${baseUrl}/modules/isaf`;
}

export function isafModuleUpdateUrl() {
  return `${baseUrl}/modules/isaf/update`;
}

export function finvaldaModuleEditUrl() {
  return `${moduleIndexUrl()}/finvalda`;
}

export function finvaldaModuleUpdateUrl() {
  return `${moduleIndexUrl()}/finvalda`;
}

export function ovokoModuleEditUrl() {
  return `${moduleIndexUrl()}/ovoko`;
}

export function ovokoModuleUpdateUrl() {
  return `${moduleIndexUrl()}/ovoko/update`;
}

export function ovokoCheckUrl() {
  return `${baseUrl}/ovoko-check`;
}

export function ovokoInvoicesImportUrl() {
  return `${baseUrl}/ovoko-invoices-import`;
}

export function waybillModuleEditUrl() {
  return `${moduleIndexUrl()}/waybill`;
}

export function waybillModuleUpdateUrl() {
  return `${moduleIndexUrl()}/waybill/update`;
}

export function expensesModuleEditUrl() {
  return `${moduleIndexUrl()}/expenses`;
}

export function periodicInvoicesModuleEditUrl() {
  return `${moduleIndexUrl()}/periodic-invoices`;
}

export function periodicInvoicesModuleUpdateUrl() {
  return `${moduleIndexUrl()}/periodic-invoices/update`;
}

export function woocommerceModuleIndexUrl() {
  return `${moduleIndexUrl()}/woocommerce`;
}

export function woocommerceModuleEditUrl(key = null) {
  return `${moduleIndexUrl()}/woocommerce/edit/${key}`;
}

export function woocommerceModuleUpdateUrl() {
  return `${moduleIndexUrl()}/woocommerce/update`;
}

export function apsaModuleEditUrl() {
  return `${moduleIndexUrl()}/apsa`;
}

export function verskisModuleEditUrl() {
  return `${moduleIndexUrl()}/verskis`;
}

export function verskisModuleUpdateUrl() {
  return `${moduleIndexUrl()}/verskis`;
}

export function verskisCheckUrl(url = null, key = null) {
  return `${baseUrl}/verskis-check?url=${url}&key=${key}`;
}

export function verskisInvoicesImportUrl() {
  return `${baseUrl}/verskis-invoices-import`;
}

export function ivModuleEditUrl() {
  return `${baseUrl}/modules/iv`;
}

export function ivModuleUpdateUrl() {
  return `${baseUrl}/modules/iv`;
}

export function companyVatLimitModuleEditUrl() {
  return `${moduleIndexUrl()}/company-vat-limit`;
}

export function companyVatLimitModuleUpdateUrl() {
  return `${moduleIndexUrl()}/company-vat-limit`;
}

export function shopifyModuleIndexUrl() {
  return `${moduleIndexUrl()}/shopify`;
}

export function ivCalculatortModuleEditUrl() {
  return `${moduleIndexUrl()}/iv-calculator`;
}

export function invoicePaymentEmailReminderModuleEditUrl() {
  return `${moduleIndexUrl()}/invoice-payment-email-reminder`;
}

export function invoicePaymentEmailReminderModuleUpdateUrl() {
  return `${moduleIndexUrl()}/invoice-payment-email-reminder`;
}

export function invoicePaymentEmailReminderTestUrl() {
  return `${moduleIndexUrl()}/invoice-payment-email-reminder-test`;
}

export function warehousesModuleEditUrl() {
  return `${moduleIndexUrl()}/warehouses`;
}

export function warehousesModuleUpdateUrl() {
  return `${moduleIndexUrl()}/warehouses/update`;
}

export function pragmaModuleEditUrl() {
  return `${moduleIndexUrl()}/pragma`;
}

export function pragmaModuleUpdateUrl() {
  return `${moduleIndexUrl()}/pragma/update`;
}

export function montonioModuleEditUrl() {
  return `${moduleIndexUrl()}/direct-payment`;
}

export function montonioModuleUpdateUrl() {
  return `${moduleIndexUrl()}/direct-payment/update`;
}

export function reportsModuleEditUrl() {
  return `${moduleIndexUrl()}/reports`;
}

export function profitCalculatorModuleEditUrl() {
  return `${moduleIndexUrl()}/profit-calculator`;
}

export function profitCalculatorModuleUpdateUrl() {
  return `${moduleIndexUrl()}/profit-calculator`;
}

export function workActModuleEditUrl() {
  return `${moduleIndexUrl()}/work-act`;
}

export function workActModuleUpdateUrl() {
  return `${moduleIndexUrl()}/work-act/update`;
}

export function butentaModuleEditUrl() {
  return `${moduleIndexUrl()}/butenta`;
}

export function butentaModuleUpdateUrl() {
  return `${moduleIndexUrl()}/butenta/update`;
}

export function signatureModuleEditUrl() {
  return `${moduleIndexUrl()}/signature`;
}

export function signatureModuleUpdateUrl() {
  return `${moduleIndexUrl()}/signature`;
}

export function prestashopModuleIndexUrl() {
  return `${moduleIndexUrl()}/prestashop`;
}

export function prestashopModuleEditUrl(key = null) {
  return `${moduleIndexUrl()}/prestashop/edit/${key}`;
}

export function prestashopModuleUpdateUrl() {
  return `${moduleIndexUrl()}/prestashop/update`;
}

export function eskolaModuleEditUrl() {
  return `${moduleIndexUrl()}/eskola`;
}

export function eskolaModuleUpdateUrl() {
  return `${moduleIndexUrl()}/eskola/update`;
}

export function eskolaRemoveInvoiceStatusUrl(id) {
  return `${moduleIndexUrl()}/eskola/remove-invoice-status/${id}`;
}

export function eskolaApiSyncUrl() {
  return `${moduleIndexUrl()}/eskola/api-sync`;
}

export function eskolaSignatureStatusUpdateUrl() {
  return `${moduleIndexUrl()}/eskola/update-signature-status`;
}

export function tagsModuleEditUrl() {
  return `${moduleIndexUrl()}/tags`;
}

export function jumisModuleEditUrl() {
  return `${moduleIndexUrl()}/jumis`;
}

export function opencartModuleIndexUrl() {
  return `${moduleIndexUrl()}/opencart`;
}

export function opencartModuleEditUrl(key = null) {
  return `${moduleIndexUrl()}/opencart/edit/${key}`;
}

export function opencartModuleUpdateUrl() {
  return `${moduleIndexUrl()}/opencart/update`;
}

export function payseraPaymentModuleEditUrl() {
  return `${moduleIndexUrl()}/paysera-payment`;
}

export function payseraPaymentModuleUpdateUrl() {
  return `${moduleIndexUrl()}/paysera-payment/update`;
}

export function sabisModuleEditUrl() {
  return `${moduleIndexUrl()}/sabis`;
}

export function sabisModuleUpdateUrl() {
  return `${moduleIndexUrl()}/sabis/update`;
}

export function rivileERPModuleEditUrl() {
  return `${moduleIndexUrl()}/rivile-erp`;
}

export function rivileERPModuleUpdateUrl() {
  return `${moduleIndexUrl()}/rivile-erp`;
}

export function nodaModuleEditUrl() {
  return `${moduleIndexUrl()}/noda`;
}

export function nodaModuleUpdateUrl() {
  return `${moduleIndexUrl()}/noda/update`;
}

export function activityLogModuleEditUrl() {
  return `${moduleIndexUrl()}/activity-log`;
}

export function b1ModuleEditUrl() {
  return `${moduleIndexUrl()}/b1`;
}

export function b1ModuleUpdateUrl() {
  return `${moduleIndexUrl()}/b1/update`;
}

export function b1ModuleCheckUrl() {
  return `${baseUrl}/b1-check`;
}

export function etsyModuleEditUrl() {
  return `${moduleIndexUrl()}/etsy`;
}

export function etsyModuleUpdateUrl() {
  return `${moduleIndexUrl()}/etsy/update`;
}

export function etsyConnectUrl() {
  return `${moduleIndexUrl()}/etsy/connect`;
}

export function etsyRequestAccessTokenUrl() {
  return `${moduleIndexUrl()}/etsy/request-access-token`;
}

export function etsyImportInvoicesUrl() {
  return `${moduleIndexUrl()}/etsy/import-invoices`;
}

export function etsyRefreshConnectionUrl() {
  return `${moduleIndexUrl()}/etsy/refresh-connection`;
}
